export const LOCAL_STORAGE_KEY_BASKET = 'pride.basket'

export const LOCAL_STORAGE_KEY_BASKET_LIST = 'pride.basket-list'

export const LOCAL_STORAGE_KEY_CURRENT_BASKET_UID = 'pride.current-basket-uid'

export const LOCAL_STORAGE_KEY_FAVORITE = 'pride.favorite'

export const LOCAL_STORAGE_KEY_COMPARISON = 'pride.comparison'

export const LOCAL_STORAGE_KEY_VIEWED = 'pride.viewed'


export const LOCAL_STORAGE_KEY_SEARCH_STRING = 'pride.search-string'

export const LOCAL_STORAGE_KEY_CUSTOMER = 'pride.customer'

export const LOCAL_STORAGE_DELIMITER = ','

export const PROPERTY_KEY_BRAND_ORIGIN = '1388143292'

